import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/auth/sign-in/page.tsx")